import styled from "styled-components/macro";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TermsHTML from "./TermsHTML";
import PrivacyHTML from "./PrivacyHTML";
import { RAVEN_TERMS_URL } from "./Nav/Drawers/RightDrawer/RightDrawerContent";
import { brightBlue } from "../constants/colors";
import { FONT_SIZE_LARGE } from "../constants/constants";
import { CUSTOM_SCROLLBAR_CSS } from "App/CUSTOM_SCROLLBAR_CSS";

const TermsPrivacyStyles = styled.div`
  width: 90vw;
  max-width: 900px;
  margin: auto;
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: white;
  .btnClose {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  .modalContentWrapper {
    overflow-y: scroll;
    overflow-x: hidden;
    ${CUSTOM_SCROLLBAR_CSS}

    position: relative;
    width: 100%;
    height: 100%;
  }
  .modalContent {
    position: absolute;
    top: 0;
    padding: 20px;
    font-family: "Roboto";
    line-height: 1.5em;
    h1 {
      color: ${brightBlue};
      font-size: ${FONT_SIZE_LARGE}px;
      text-align: center;
      padding-bottom: 2em;
    }
    &.privacy {
      h1 {
        padding-top: 2em;
      }
    }
    p {
      margin-bottom: 1em;
    }
    br {
      line-height: 2em;
    }
    strong {
      font-weight: bold;
    }
  }
`;

const TermsPrivacyModal = ({ src, setTermsPrivacySrc, ...rest }) => {
  return (
    <TermsPrivacyStyles>
      <div className="modalContentWrapper">
        <div
          className={`modalContent ${
            src === RAVEN_TERMS_URL ? "terms" : "privacy"
          }`}
          dangerouslySetInnerHTML={{
            __html: src === RAVEN_TERMS_URL ? TermsHTML : PrivacyHTML,
          }}
        />
      </div>
      <IconButton
        className="btnClose"
        onClick={() => setTermsPrivacySrc(null)}
        size="large"
      >
        <CloseIcon />
      </IconButton>
    </TermsPrivacyStyles>
  );
};

export default TermsPrivacyModal;
